import { supabase } from '@/lib/supabase'
import type { GovernmentWithDetails } from '@/types'

export const governmentKeys = {
  all: ['governments'] as const,
  byElection: (electionId: string) => ['governments', 'election', electionId] as const,
  byNation: (nationId: string) => ['governments', 'nation', nationId] as const,
}

/**
 * Fetches the government formed for a specific election.
 * Returns null if no government has been formed yet.
 */
export async function fetchGovernmentByElection(
  electionId: string,
): Promise<GovernmentWithDetails | null> {
  const { data, error } = await supabase
    .from('governments')
    .select(`
      *,
      lead_party:parties(id, name, abbreviation, color)
    `)
    .eq('election_id', electionId)
    .maybeSingle()

  if (error) {
    throw new Error(`Failed to fetch government: ${error.message}`)
  }

  return data as GovernmentWithDetails | null
}
